<template>
  <b-input
    type="text"
    data-cy="rule-number"
    v-model="vm.localModel"
    pattern="[/^\d*\.?\d*$/]"
    inputmode="decimal"
    autocomplete="off"
    lang="de-DE"
    v-tooltip="validationFeedback"
    :class="{ 'border-danger': validationFeedback }"
    :disabled="vm.disabled" />
</template>

<script setup lang="ts">
import { useState } from "vuex-composition-helpers";
import { computed, reactive, watch } from "vue";
import { useI18n } from "vue-i18n";
import { NumberParser } from "@util/numberParse";
import { RootState } from "@medapro-types/common/rootstate";

const { userSettings } = useState<RootState>(["userSettings"]);
const { n: $n, t: $t } = useI18n();

//#region General
const props = defineProps<{ value: string }>();
const emits = defineEmits(["input"]);
//#endregion

//#region ViewModel
const parser = new NumberParser(userSettings.value.CurrentLocale);
const initValueHelper = parseFloat(props.value);
type ViewModel = { localModel: string | null; disabled: boolean };
const vm = reactive<ViewModel>({ localModel: isNaN(initValueHelper) ? null : $n(initValueHelper), disabled: false });
//#endregion

//#region Update vModel
watch(
  () => vm.localModel,
  (nv) => {
    emits("input", `${parser.parseLocaleStringToIndepentendNumberString(nv) ?? ""}`);
  },
  { immediate: true }
);
//#endregion

//#region Validation
const validationFeedback: Record<string, any> = computed(() => {
  const result = Number(parser.parseLocaleStringToIndepentendNumberString(vm.localModel));
  return typeof result === "number" && Number.isFinite(result) ? "" : $t("ValueIsNotNumber");
});
//#endregion
</script>
